import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-border bg-cream/40 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 flex flex-col items-center text-center gap-5">
        <Link to="/" className="flex items-center gap-3 group" data-testid="footer-logo">
          <img
            src="/logo.png"
            alt="Les Amis de Lili"
            className="w-14 h-14 rounded-full object-cover ring-1 ring-border transition-transform group-hover:scale-105"
          />
          <div className="text-left leading-tight">
            <div className="font-serif-display text-xl text-ink">Les Amis de Lili</div>
            <div className="font-script text-terracotta text-base -mt-1">{t.nav.tagline}</div>
          </div>
        </Link>
        <p className="font-body text-sm text-muted-foreground max-w-md leading-relaxed">
          {t.footer.description}
        </p>
      </div>
      <div className="border-t border-border/70">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} Les Amis de Lili — {t.footer.rights}</span>
          <span className="font-script text-base text-camel">fait main avec ♥</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
